import { z } from "zod";

import type { SampleFieldBuiltIn } from "@blis/prisma";

export const builtIns: Record<SampleFieldBuiltIn, string> = {
  COLLECTION_DATETIME: "Collection datetime",
  REFRIGERATION_DATETIME: "Refrigeration datetime",
  CENTRIFUGATION_DATETIME: "Centrifugation datetime",
  LOT_NUMBER: "Lot number",
  LOT_EXPIRATION_DATE: "Lot expiration date",
  QUANTITY: "Quantity",
  TRANSFUSION_STATUS: "Transfusion status",
  PATIENT_STATUS: "Patient status",
};

export const create = z.object({
  name: z.string().min(1, "Required"),
  required: z.boolean().optional(),
});

export const update = create.extend({ id: z.number() });

export const addField = z.object({
  fieldSetId: z.number(),
  fieldSpecId: z.number().nullish(),
  builtIn: z
    .enum(
      Object.keys(builtIns) as [SampleFieldBuiltIn, ...SampleFieldBuiltIn[]],
    )
    .optional(),
  required: z.boolean().default(true),
  showOnReport: z.boolean().default(true),
});

export const updateField = z.object({
  id: z.number(),
  required: z.boolean(),
  showOnReport: z.boolean(),
});
